"use client"

import styled, { css } from "styled-components"

import { Button } from "../Button"

export const ShowMoreButton = styled(Button)`
  ${({ theme, $center, secondary }) => {
    const { spaces } = theme
    return css`
      align-self: ${$center ? "center" : "flex-start"};
      padding: ${!secondary && spaces.xs};
    `
  }}
`
